/**
 * 준비 단계(헤더·fingerprint 로드)까지 같은 abort 경계에 넣는다.
 * fetch 만 signal 을 보면, 그 전 단계가 늘어질 때 취소·타임아웃이 먹지 않아 전역 잠금이 남는다.
 */
const abortReason = (signal: AbortSignal): unknown =>
  signal.reason ?? new DOMException('The operation was aborted.', 'AbortError');

export const withAbort = async <T>(
  task: Promise<T>,
  signal: AbortSignal,
): Promise<T> => {
  if (signal.aborted) throw abortReason(signal);

  let onAbort: () => void = () => undefined;
  const aborted = new Promise<never>((_, reject) => {
    onAbort = () => reject(abortReason(signal));
    signal.addEventListener('abort', onAbort, { once: true });
  });

  try {
    return await Promise.race([task, aborted]);
  } finally {
    signal.removeEventListener('abort', onAbort);
  }
};
